import React, { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react';
import { getProjectById } from '../data/projects';
import type { Project } from '../types/content';
interface ProjectDrawerValue {
  activeProject: Project | null;
  openProject: (id: string, trigger?: HTMLElement | null) => void;
  closeProject: () => void;
}
const ProjectDrawerContext = createContext<ProjectDrawerValue | null>(null);
export function ProjectDrawerProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [activeId, setActiveId] = useState<string | null>(null);
  const triggerRef = useRef<HTMLElement | null>(null);
  const openProject = useCallback((id: string, trigger?: HTMLElement | null) => {
    triggerRef.current = trigger ?? document.activeElement as HTMLElement | null;
    setActiveId(id);
  }, []);
  const closeProject = useCallback(() => {
    setActiveId(null);
    const trigger = triggerRef.current;
    window.setTimeout(() => {
      if (trigger && trigger.isConnected) trigger.focus({
        preventScroll: true
      });
    }, 0);
  }, []);
  const activeProject = useMemo(() => activeId ? getProjectById(activeId) ?? null : null, [activeId]);
  const value = useMemo(() => ({
    activeProject,
    openProject,
    closeProject
  }), [activeProject, openProject, closeProject]);
  return <ProjectDrawerContext.Provider value={value} data-id="element-498" data-mp="1xicozbic2f62">{children}</ProjectDrawerContext.Provider>;
}
export function useProjectDrawer() {
  const value = useContext(ProjectDrawerContext);
  if (!value) throw new Error('useProjectDrawer must be used inside ProjectDrawerProvider');
  return value;
}